/**
 * Business phone number rendered across the site. Keep it in one of the
 * formats CallRail's dynamic number insertion recognizes (111-222-3333,
 * 111.222.3333 or (111) 222-3333) so swap.js can replace it with a tracking
 * number.
 */
export const PHONE_DISPLAY = "305-417-6299";
export const PHONE_HREF = "tel:+1" + PHONE_DISPLAY.replace(/\D/g, "");
